import * as React from "react";
import { useTranslation } from "react-i18next";
const NullCacheSummary = () => {
  const { t } = useTranslation("lookup_tables");
  return /* @__PURE__ */ React.createElement("p", null, t("cache_summary.no_configuration"));
};
export default NullCacheSummary;
